export default __webpack_public_path__ + "static/media/u_eye_splash_hide.38dba9ca.svg";